module.exports = __webpack_public_path__ + "static/media/scr1.a723b5f4.png";